import PatientDocuments from './PatientDocuments';

export default PatientDocuments;
